<template>

    <div style="height: 100vh;width: 100vw;position: relative;">
      <div class="notify_area" >
        <div style="width: 200px;">
          <span class="square" style="background:#409EFF;"></span>
          <span class="text">在线用户</span>
        </div>
        <div style="width: 200px;">
          <span class="square" style="background: red;"></span>
          <span class="text">离线用户</span>
        </div>
      </div>
        <el-form
      :model="searchForm"
      ref="searchFormRef"
      label-width="100px"
      label-suffix=":"
   
    >
      <el-row :gutter="24">
        <el-col :span="6">
          <el-form-item label="服务网点" prop="nursinghomeId">
            <el-select
              v-model="searchForm.nursinghomeId"
              style="width: 100%"
              placeholder="项目名称"
              @change="nursinghomeIdChange"
            >
              <el-option
                v-for="item in nursinghomeIdList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        

        <el-col :span="12">
          <div style="float: right">
            <el-button type="primary" icon="el-icon-search" @click="searchRecord" size="small">
              搜索
            </el-button>
           
          </div>
        </el-col>
      </el-row>
    </el-form>
      <div id="amapcontainer"></div>
    </div>
  </template>
  
  <script>
import {  getNursinghome,  } from '../api/serveItemManage.js';
import { getLocationData } from '@/api/nursingHome/security.js';
  export default {
    data() {
      return {
        map:{},
        nursinghomeIdList:[],
        searchForm:{
            nursinghomeId:"",
        },
        mouseTool:{},
        path : [
      
        ],
        deviceList:[],
        pointerList:[],
      }
    },
    created(){
     
    },
    mounted() {
        this.initAMap()
        this.initData()
    
    },
    methods: {
     initData(){
        getNursinghome().then((res) => {
        this.nursinghomeIdList = res.data;
        if (this.nursinghomeIdList.length > 0) {
          this.$set(this.searchForm, 'nursinghomeId', this.nursinghomeIdList[0].id);
          this.$set(this.searchForm, 'nursinghomeName', this.nursinghomeIdList[0].name);
         
         this.getLocationData()
        }
      });
     },
      initAMap () {
        this. map = new AMap.Map('amapcontainer', {
                zoom: 13,//级别 3-17  越大显示越细节
                 center: [114.54,30.49],//中心点坐标
                // center: [116.397428, 39.90923],  //设置地图中心点坐标
   
                // viewMode: '2D'//使用3D视图
           });
        //实时路况图层
      	var trafficLayer = new AMap.TileLayer.Traffic({
             zIndex: 10
        });
        this.map.add(trafficLayer);//添加图层到地图
        

    
      

    },

    getLocationData(){
        getLocationData(this.searchForm).then(res=>{
            this.deviceList=res.data
            this.drawRPointer()
        })
    },
    drawRPointer(){
        this.pointerList.forEach(item=>{
            this.map.remove(item);
        })
       
        this.deviceList.forEach(item=>{
            if(item.gpsCurrentLocation!=null){
                let position = item.gpsCurrentLocation.split(",")
                if(item.onlineStatus=="2"){
                    const marker = new AMap.Marker({
                    position: new AMap.LngLat(position[0],position[1]),
                    title: item.deviceName+"  "+item.elderlyInfo,
                    offset: new AMap.Pixel(-10, -10),
                    icon:'https://webapi.amap.com/theme/v1.3/markers/n/mark_rs.png',
                })
                this. map.add(marker);
                this.pointerList.push(marker)
                }else{
                    if(item.onlineStatus=="1"){
                    const marker = new AMap.Marker({
                    position: new AMap.LngLat(position[0],position[1]),
                    title: item.deviceName+"  "+item.elderlyInfo,
                    offset: new AMap.Pixel(-10, -10),
                   
                })
                this. map.add(marker);
                this.pointerList.push(marker)
                }
                
               
            }
            }
            
        })
    },
    searchRecord(){
        this.getLocationData()
    },
    drawRectangle () {
      const vm = this;
      this.mouseTool = new AMap.MouseTool(this.map);
      const polygon = this.mouseTool.polygon({
        strokeColor: 'red',
        strokeOpacity: 0.5,
        strokeWeight: 6,
        fillColor: 'blue',
        fillOpacity: 0.5,
        // strokeStyle还支持 solid
        strokeStyle: 'solid',
        // strokeDasharray: [30,10],
      });
      vm.editRectangle(vm.path);
       
      
    },

    }
  }
</script>
<style  scoped>

#amapcontainer {
  width: 100%;
  height: 1000px;
}
.notify_area{
  position: absolute;
 
  height: 60px;
  width: 200px;
  z-index: 9999;
  right: 0;
  right: 300px;
    top: 74px;
    background: #f5f6f8;
  padding: 20px;
}
.square{
  display: inline-block;
  width: 25px;
  height: 25px;
  
}
.text{
  margin-left: 50px;
    /* text-align: center; */
    height: 25px;
    display: inline-block;
    line-height: 25px;
    transform: translateY(-25%);
}
</style>